import { Grid } from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { convertToJalali, formatGregorianDate } from "../../../../utils/date";
import { convertToTime } from "../../../../utils/time";
import { t } from "i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import general components
import { BaseButton } from "../../../../components/common/base-button/base-button";
import BaseTable from "../../../common/base-table/base-table";

//import styles
import "./all-request.scss";

function AllRequest({ requestList, handleChangeStatusButton, loading }) {
    //general
    const { locale } = useContext(LocaleContext);

    //table's columns
    const columns = useMemo(() => [
        {
            accessorKey: "label",
            header: `${t("title")}`,
            enableSorting: false,
        },
        {
            accessorKey: "category",
            header: `${t("category")}`,
            enableSorting: false,
        },
        {
            accessorKey: "dateTime",
            header: `${t("dateAndTime")}`,
            enableSorting: false,
        },
        {
            accessorKey: "status",
            header: `${t("status")}`,
            enableSorting: false,
        },
        {
            accessorKey: "viewChat",
            header: "",
            enableSorting: false,
            size: 90,
        },
    ]);

    //table's rows
    const [rows, setRows] = useState([]);
    useEffect(() => {
        if (!!requestList?.requests?.length) {
            setRows(
                requestList?.requests?.map(requestItem => ({
                    label: requestItem?.title,
                    category: requestItem?.type,
                    dateTime:
                    locale === "fa" ?  convertToJalali(requestItem.register_date) : formatGregorianDate(requestItem.register_date, null, "YYYY/MM/DD") +
                         " - " +
                         convertToTime(requestItem.register_date)
                         ,
                    status: locale === "en" ? requestItem.status.en : requestItem.status.fa,
                    viewChat: (
                        <BaseButton
                            text={t("checkStatus")}
                            color="secondary"
                            size="large"
                            radius="radius-10"
                            type="submit"
                            handleClick={() => handleChangeStatusButton(true, requestItem.id)}
                        />
                    ),
                })),
            );
        }
    }, [requestList]);

    return (
        <>
            <Grid className="all-request" container item xs={12} display={{ xs: "none", md: "flex" }} mb={{ xs: 13, sm: 20, md: 0 }}>
                <BaseTable columns={columns} rows={rows} details={false} action={false} loading={loading} rowBackground="var(--light-color)" />
            </Grid>

            <Grid className="all-request" container item xs={12} rowGap={2} display={{ xs: "flex", md: "none" }} mb={{ xs: 18, sm: 20, md: 0 }}>
                {requestList?.requests?.map(requestItem => {
                    return (
                        <Grid
                            className="all-request__request-item"
                            container
                            item
                            xs={12}
                            rowGap={1}
                            onClick={() => handleChangeStatusButton(true, requestItem.id)}
                        >
                            <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                                <span className="all-request__title">{requestItem?.title}</span>
                                <span className={`all-request__status ${requestItem.status.en}`}>
                                    {locale === "en" ? requestItem.status.en : requestItem.status.fa}
                                </span>
                            </Grid>
                            <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                                <span className="all-request__category">{requestItem?.type}</span>
                                <span className="all-request__date-time">
                                    {convertToTime(requestItem.register_date)} {" - "}{" "}
                                    {locale === "fa"
                                        ? convertToJalali(requestItem.register_date)
                                        : formatGregorianDate(requestItem.register_date, null, "YYYY/MM/DD")}
                                </span>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </>
    );
}

export default AllRequest;
